<p class="terms">
    By continuing, you agree to our
    <a [routerLink]="'/privacy-notice'" target="_blank">Terms of Service</a> and
    <a [routerLink]="'/privacy-notice'" target="_blank">Privacy Policy</a>
</p>